import { pushHistory } from '@jetshop/core/components/Filters/utils/pushHistory';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import qs from 'qs';
import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import logWarningInDev from '../../helpers/logWarningInDev';
const updateHistory = ({ history, location }, newPage) => {
    const currentSearch = qs.parse(location.search, { ignoreQueryPrefix: true });
    const search = Object.assign({}, currentSearch, { page: newPage });
    pushHistory({
        history,
        pathname: location.pathname,
        hash: location.hash,
        search,
        resetPage: newPage === 1,
        routeType: 'paginationChange'
    });
    return true;
};
const getPageFromSearch = (location) => {
    let page = null;
    // Get the page from the search parameter in the URL
    if (location.search) {
        page = parseInt(qs.parse(location.search, { ignoreQueryPrefix: true }).page, 10);
    }
    return page;
};
const calculateOffset = (page, perPage) => (page - 1) * perPage;
const PaginationProvider = ({ cookies, defaultProductsPerPage = 16, location, history, children }) => {
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        const page = getPageFromSearch(location);
        if (page) {
            setCurrentPage(page);
        }
        if (!page && currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [location]);
    const goToPage = useCallback((page) => {
        setCurrentPage(page);
        updateHistory({ location, history }, page);
    }, [location, history]);
    const setProductsPerPage = useCallback((perPage) => {
        cookies.set('perPage', `${perPage}`);
        setCurrentPage(1);
    }, [cookies]);
    const cookieProductsPerPage = parseInt(cookies.get('perPage'), 10);
    const perPage = cookieProductsPerPage || defaultProductsPerPage;
    const value = useMemo(() => ({
        currentPage,
        offset: calculateOffset(currentPage, perPage),
        perPage,
        goToPage,
        setProductsPerPage
    }), [currentPage, perPage, goToPage, setProductsPerPage]);
    if (typeof children === 'function') {
        logWarningInDev(true, 'The child-as-function syntax of PaginationProvider has been deprecated. Please move to usePagination instead.');
        return (React.createElement(PaginationContext.Provider, { value: value }, children({
            offset: value.offset,
            perPage: value.perPage
        })));
    }
    else {
        return (React.createElement(PaginationContext.Provider, { value: value }, children));
    }
};
export function usePagination() {
    return useContext(PaginationContext);
}
// We need withRouter in this component so we can push to history and pull from location
export default withRouter(withCookies(PaginationProvider));
//# sourceMappingURL=PaginationProvider.js.map